import { create } from 'zustand'
import { message } from 'antd'
import { UserInfoResponse } from '../types/user'
import { axiosInstance } from '@/shared'

interface UserInfoStore {
  info: UserInfoResponse
  fetch: () => Promise<UserInfoResponse | undefined>
}

export const useUserInfoStore = create<UserInfoStore>((set) => ({
  info: {
    id: '',
    email: '',
    name: '',
    role: 'user' as const,
    isArchived: false,
    lastLoginAt: null,
    createdAt: '',
  },
  fetch: async () => {
    try {
      const { data: info } = await axiosInstance.get<UserInfoResponse>('/users/me')

      set({ info })
      return info
    } catch (e) {
      message.error(String(e))
    }
  },
}))
